/**
 * @component FlowMdEditor
 * @description Split-Editor für FlowAI-Skills/Playbooks. Links Textarea (Markdown
 *  inkl. YAML-Frontmatter), rechts Live-Preview via react-markdown + remark-gfm.
 *  Bewusst NICHT Tiptap — Output muss reines Markdown bleiben.
 *
 * @prop {string}   value
 * @prop {function} onChange
 * @prop {number}   [minHeight=420]
 * @prop {boolean}  [showPreview=true]
 *
 * @since v2.484.0
 */
import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function FlowMdEditor({ value = '', onChange, minHeight = 420, showPreview = true }) {
  const [mode, setMode] = useState('edit');
  return (
    <div className="border border-[var(--border-subtle,#E5E7EB)] rounded-lg overflow-hidden">
      <div className="flex items-center gap-1 px-2 py-1.5 border-b border-[var(--border-subtle,#E5E7EB)] bg-[var(--bg-inset,#F8F9FC)]">
        <button
          type="button"
          onClick={() => setMode('edit')}
          className={`text-xs px-2.5 py-1 rounded ${mode === 'edit' ? 'bg-white shadow-sm font-medium' : 'text-[var(--text-secondary,#4B5563)]'}`}
        >
          Edit
        </button>
        {showPreview && (
          <>
            <button
              type="button"
              onClick={() => setMode('preview')}
              className={`text-xs px-2.5 py-1 rounded ${mode === 'preview' ? 'bg-white shadow-sm font-medium' : 'text-[var(--text-secondary,#4B5563)]'}`}
            >
              Preview
            </button>
            <button
              type="button"
              onClick={() => setMode('split')}
              className={`text-xs px-2.5 py-1 rounded ${mode === 'split' ? 'bg-white shadow-sm font-medium' : 'text-[var(--text-secondary,#4B5563)]'}`}
            >
              Split
            </button>
          </>
        )}
        <span className="text-[10px] text-[var(--text-tertiary,#6B7280)] ml-auto">Markdown + YAML-Frontmatter</span>
      </div>
      <div className="grid" style={{ gridTemplateColumns: mode === 'split' ? '1fr 1fr' : '1fr' }}>
        {(mode === 'edit' || mode === 'split') && (
          <textarea
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            spellCheck={false}
            className="w-full p-3 text-[12px] font-mono leading-relaxed bg-white outline-none resize-none border-0 border-r border-[var(--border-subtle,#E5E7EB)]"
            style={{ minHeight }}
          />
        )}
        {(mode === 'preview' || mode === 'split') && (
          <div
            className="p-4 text-[13px] bg-white overflow-auto prose prose-sm max-w-none"
            style={{ minHeight }}
          >
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{value || '_(leer)_'}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
}
